import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isQaRole } from '../config/qaPermissions';
import { CircularProgress, Box } from '@mui/material';

interface QaProtectedRouteProps {
  children: React.ReactNode;
}

// Mirror of AdminProtectedRoute, but gated by isQaRole (QA/ADMIN/OWNER).
const QaProtectedRoute: React.FC<QaProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user || !isQaRole(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default QaProtectedRoute;
